import { Component } from 'react';
import DownloadBlack from '../common/downloadBlack';
import { Api } from '../../api';

const api = new Api();

interface State {
  isInputOpen: boolean;
}
class BlackBanner extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isInputOpen: false,
    };
  }

  private changeClassName = (value: boolean) => {
    this.setState({
      isInputOpen: value,
    });
  };

  private async sendBlackSMS(phone: string) {
    const returnVal = await api.sendBlackSMS(phone);
    await api.recordBlackSMSSheet(phone);
    return returnVal;
  }

  public render() {
    const { openQRModal } = this.props;
    return (
      <div className="lil-w-full lil-flex lil-justify-center lil-flex-wrap lil-flex-row-reverse lil-mt-12 sm:lil-flex-col-reverse ">
        <div className="lil-w-1/2 lil-items-center lil-flex sm:lil-w-full lil-pl-16 sm:lil-p-4 lil-bg-grey-600">
          <div className="lil-w-full sm:lil-w-full">
            <h4 className="sm:lil-text-s-28 lil-text-white">
              Introducing BLACK.
              <br /> ClearTax on the go
            </h4>
            <div className="lil-flex lil-pt-8 sm:lil-w-full lil-w-3/4">
              <div className="lil-w-1/6 xl:lil-w-1/12">
                <img
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1606245340_chooseyourexperts.svg"
                  height="40"
                  width="40"
                />
              </div>
              <div className="lil-px-6 lil-w-5/6">
                <p className="lil-text-font-500 lil-font-bold lil-text-base lil-text-white">
                  File in minutes from your phone
                </p>
                <p className="lil-text-base lil-pt-2">
                  From uploading docs to filine your return. Get done in just 7
                  minutes without opening your laptops.
                </p>
              </div>
            </div>
            <div className="lil-flex lil-pt-8 sm:lil-w-full lil-w-3/4">
              <div className="lil-w-1/6 xl:lil-w-1/12">
                <img
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1605685611_choosefromexperts.svg"
                  height="40"
                  width="40"
                />
              </div>
              <div className="lil-px-6 lil-w-5/6">
                <p className="lil-text-font-500 lil-font-bold lil-text-base lil-text-white">
                  Invest and save taxes
                </p>
                <p className="lil-text-base lil-pt-2">
                  Now you can easily drag & drop your Form 16’s to start your
                  invest
                </p>
              </div>
            </div>
            <div className="lil-flex lil-pt-8 sm:lil-w-full lil-w-3/4">
              <div className="lil-w-1/6 xl:lil-w-1/12">
                <img
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1605685687_servicebyexperts.svg"
                  height="40"
                  width="40"
                />
              </div>
              <div className="lil-px-6 lil-w-5/6">
                <p className="lil-text-font-500 lil-font-bold lil-text-base lil-text-white">
                  Get expert assistance
                </p>
                <p className="lil-text-base lil-pt-2">
                  Choose from over 200 expert services for filing complex
                  returns to incorporating your company.
                </p>
              </div>
            </div>
            <div className="lil-flex lil-flex-wrap lil-items-center lil-pt-12 sm:lil-flex-col sm:lil-mt-8">
              <div className="sm:lil-hidden">
                <DownloadBlack
                  classname="lil-text-white"
                  btnText="Download black app"
                  onShowInput={this.changeClassName}
                  sendBlackSMS={this.sendBlackSMS}
                  inputWidth="250px"
                />
              </div>
              <div className="xl:lil-hidden lg:lil-hidden md:lil-hidden">
                <a
                  className="lil-btn lil-btn-blue"
                  href="https://black-cleartax.app.link/cTxO5GMgneb"
                >
                  Download black app
                </a>
              </div>

              <div
                className={` ${
                  this.state.isInputOpen ? 'lil-w-full lil-pt-6' : ''
                } `}
              >
                <div className="lil-flex lil-px-2 lil-cursor-pointer md:lil-w-4/5 md:lil-py-6 md:lil-px-0 sm:lil-w-full sm:lil-justify-center sm:lil-px:0 sm:lil-py-6">
                  <img src="https://assets1.cleartax-cdn.com/cleartax/images/1633600809_scanqr.svg" />
                  <a
                    onClick={() => openQRModal()}
                    className="lil-px-3 lil-font-bold lil-text-white"
                  >
                    Download via QR
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lil-w-1/2 lil-flex lil-items-center lil-justify-start sm:lil-w-full sm:lil-pb-6 lil-bg-grey-600">
          <picture>
            <source
              type="image/webp"
              srcSet="https://assets1.cleartax-cdn.com/cleartax/images/1614659076_1606106116_desktop_fold_introducingblack_lhs.webp"
            />
            <source
              type="image/jpeg"
              srcSet="https://assets1.cleartax-cdn.com/cleartax/images/1606106116_desktop_fold_introducingblack_lhs.png"
            />
            <img
              data-src="https://assets1.cleartax-cdn.com/cleartax/images/1606106116_desktop_fold_introducingblack_lhs.png"
              alt="Black"
            />
          </picture>
        </div>
      </div>
    );
  }
}

export default BlackBanner;



// WEBPACK FOOTER //
// ./components/homePageNew/blackBanner.tsx